import React from "react";

import { Text, StyleSheet, View, Platform } from "react-native";
import AppTheme from "../../AppTheme";
import Toggle from "../../common/Toggle";

export default function EditElementsToggle({ showParents, toggleParentsView }) {
  const showToggle = true; //!!element.edit_id || element.edit_is_core == 1;

  const toggleText = showParents
    ? "Parents are Elements this Element is part of"
    : "Children are Elements included in this Element";

  return (
    <View
      style={{
        marginHorizontal: 6,
        marginBottom: 10,
      }}
    >
      {showToggle ? (
        <>
          <Toggle
            selected={showParents ? "Parents" : "Children"}
            options={["Parents", "Children"]}
            selectedColor={AppTheme.toggle.blue}
            onToggle={(m) => toggleParentsView(m)}
          />

          <Text style={styles.toggleText}>{toggleText}</Text>
        </>
      ) : (
        <Text style={styles.toggleLargeText}>Choose a Parent</Text>
      )}
    </View>
  );
}

const styles = StyleSheet.create({
  toggleLargeText: {
    fontFamily:  Platform.select({ default: "Montserrat", android: "Montserrat-SemiBold" }),
    fontWeight: "600",
    fontSize: 20,
    lineHeight: 30,
    letterSpacing: 1,
    color: AppTheme.almostBlack,
    marginTop: 12,
    marginBottom: 5,
  },
  toggleText: {
    fontFamily:  Platform.select({ default: "Montserrat", android: "Montserrat-SemiBold" }),
    fontWeight: "600",
    fontSize: 12,
    lineHeight: 15,
    letterSpacing: 0.175,
    color: AppTheme.almostBlack,
    textAlign: "center",
    marginTop: 12,
    marginBottom: 5,
  },
  media: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "row",
    marginTop: 5,
  },
  bubbleContainer: {
    position: "relative",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "row",
  },
  bubbleText: {
    position: "absolute",
    left: 20,
    top: 20,
    fontFamily:  Platform.select({ default: "Montserrat", android: "Montserrat-SemiBold" }),
    fontWeight: "600",
    fontSize: 14,
    lineHeight: 17,
    letterSpacing: 0.175,
    color: "#FFF",
    maxWidth: 150,
    height: "90%",
  },
});
